import React from 'react';
import { IconProps } from '.';

type UserIconProps = {
  color?: string;
} & IconProps;

export const UserIcon: React.FC<UserIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={color}
        d="M10 0C4.49 0 0 4.49 0 10s4.49 10 10 10 10-4.49 10-10S15.51 0 10 0zM4.42 17.29c3.23-1.38 3.83-2.04 3.98-2.5.01-.04.02-.08.02-.12v-.84c0-.11-.04-.21-.12-.28-.52-.53-.91-1.26-1.15-2.12a.398.398 0 00-.16-.22.962.962 0 01-.4-.78c0-.28.12-.48.22-.6.06-.07.09-.16.09-.26V7.68c0-1.85 1.12-2.87 3.15-2.87 2.06 0 3.15.99 3.15 2.87v1.88c0 .09.03.18.09.26.1.12.22.33.22.61 0 .31-.15.61-.4.78-.08.05-.13.13-.16.22-.24.86-.64 1.59-1.15 2.12-.07.08-.12.18-.12.28v.84c0 .04.01.08.02.12.14.46.74 1.12 3.92 2.48a9.145 9.145 0 01-5.61 1.92c-2.11 0-4.04-.71-5.59-1.9zm11.88-.62c-3.14-1.32-3.71-1.91-3.81-2.09v-.6c.53-.58.94-1.34 1.2-2.21.39-.33.63-.83.63-1.35 0-.36-.11-.7-.31-1V7.68c0-2.34-1.44-3.68-3.96-3.68-2.48 0-3.96 1.38-3.96 3.68v1.75c-.2.29-.31.64-.31 1 0 .53.23 1.02.62 1.35.26.87.67 1.63 1.2 2.21v.6c-.1.18-.67.78-3.88 2.12a9.164 9.164 0 01-2.91-6.7C.81 4.94 4.93.82 10 .82c5.07 0 9.19 4.12 9.19 9.19 0 2.62-1.11 4.99-2.89 6.66z"
      ></path>
    </svg>
  );
};
